import api from "./api";

const providerService = {
  /**
   * Get provider statistics
   */
  getStats: async () => {
    const response = await api.get("/service-providers/stats");
    return response.data;
  },

  /**
   * Get provider's jobs (accepted bookings)
   */
  getJobs: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(`/service-providers/bookings?${params}`);
    return response.data;
  },

  /**
   * Get specific job details
   */
  getJobById: async (jobId) => {
    const response = await api.get(`/service-providers/bookings/${jobId}`);
    return response.data;
  },

  /**
   * Complete a job
   */
  completeJob: async (jobId, data) => {
    const response = await api.put(
      `/service-providers/bookings/${jobId}/complete`,
      data,
    );
    return response.data;
  },

  /**
   * Cancel a job (provider cancellation)
   */
  cancelJob: async (jobId, data) => {
    const response = await api.put(
      `/service-providers/bookings/${jobId}/cancel`,
      data,
    );
    return response.data;
  },

  /**
   * Get provider's pending booking links (logged in)
   */
  getBookingLinks: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(
      `/service-providers/booking-links?${params}`,
    );
    return response.data;
  },

  /**
   * Get booking link details by ID (logged in)
   */
  getBookingLinkById: async (bookingLinkId) => {
    const response = await api.get(
      `/service-providers/booking-links/${bookingLinkId}`,
    );
    return response.data;
  },

  /**
   * Accept booking link (logged in)
   */
  acceptBookingLink: async (bookingLinkId) => {
    const response = await api.post(
      `/service-providers/booking-links/${bookingLinkId}/accept`,
    );
    return response.data;
  },

  /**
   * Decline booking link (logged in)
   */
  declineBookingLink: async (bookingLinkId) => {
    const response = await api.post(
      `/service-providers/booking-links/${bookingLinkId}/decline`,
    );
    return response.data;
  },

  /**
   * Get public request details (no auth required) - FOR SMS/EMAIL LINKS
   */
  getPublicRequest: async (token) => {
    const response = await api.get(
      `/service-providers/booking-requests/${token}`,
    );
    return response.data;
  },

  /**
   * Accept booking request via token (no auth required) - FOR SMS/EMAIL LINKS
   */
  acceptRequest: async (token) => {
    const response = await api.post(
      `/service-providers/booking-requests/${token}/accept`,
    );
    return response.data;
  },

  /**
   * Decline booking request via token (no auth required) - FOR SMS/EMAIL LINKS
   */
  declineRequest: async (token) => {
    const response = await api.post(
      `/service-providers/booking-requests/${token}/decline`,
    );
    return response.data;
  },

  /**
   * Get provider's categories
   */
  getCategories: async () => {
    const response = await api.get("/service-providers/categories");
    return response.data;
  },

  /**
   * Update provider categories
   */
  updateCategories: async (data) => {
    const response = await api.put("/service-providers/categories", data);
    return response.data;
  },

  /**
   * Stripe Connect - Create account link for onboarding
   */
  createStripeAccountLink: async () => {
    const response = await api.post(
      "/service-providers/connect/create-account-link",
    );
    return response.data;
  },

  /**
   * Stripe Connect - Update account link
   */
  updateStripeAccountLink: async () => {
    const response = await api.post(
      "/service-providers/connect/update-account-link",
    );
    return response.data;
  },

  /**
   * Stripe Connect - Get account status
   */
  getStripeAccountStatus: async () => {
    const response = await api.get("/service-providers/connect/account-status");
    return response.data;
  },

  /**
   * Stripe Connect - Get dashboard link
   */
  getStripeDashboardLink: async () => {
    const response = await api.post(
      "/service-providers/connect/dashboard-link",
    );
    return response.data;
  },
};

export default providerService;
